<mat-dialog-content>
  <lemon-dialog-header> Tilintarkastajan kirjautumishistoria </lemon-dialog-header>

  <table style="padding-left: 3em; padding-right: 3em; border-spacing: 10px">
    <tr style="font-weight: bold">
      <td>ID</td>
      <td>Kirjautumistapa</td>
      <td>Laite</td>
      <td>OS</td>
      <td>Versio</td>
      <td>Pvm</td>
      <td>Kuka kirjautui?</td>
      <td>Tunnistautumissession avain</td>
    </tr>
    @for (login of data; track login) {
      <tr>
        <td>{{ login.avain }}</td>
        <td>{{ annaKirjautumistapaText(login.kirjautumistapa) }}</td>
        <td>{{ login.device }}</td>
        <td>{{ login.os }}</td>
        <td>{{ login.version }}</td>
        <td>{{ login.timestamp | ltimestamptimel: 'fi' }}</td>
        <td>{{ login.kirjautumistapa === 'superuser' ? `${login.superuserEmail} (${login.superuserAvain})` : 'Käyttäjä itse' }}</td>
        <td>{{ login.tunnistautumissessioAvain || '-' }}</td>
      </tr>
    }
  </table>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-primary-button (click)="sulje()" actionId="Sulje tilintarkastajan kirjautumishistoria">Sulje</app-primary-button>
</mat-dialog-actions>
